import {useIsFetching} from 'react-query'

import {Loader} from 'common/components'

export default function FetchLoader() {
  const isFetching = useIsFetching()

  return <Loader type="fixed" show={Boolean(isFetching)} />
}
